import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import getDay from 'date-fns/getDay';
import { es } from 'date-fns/locale';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useEffect, useState } from 'react';
import axios from 'axios';

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales: { es },
});

export default function CalendarioCitas() {
  const [eventos, setEventos] = useState([]);
  const [eventoSeleccionado, setEventoSeleccionado] = useState(null);
  const [nuevaCitaVisible, setNuevaCitaVisible] = useState(false);
  const [fechaActual, setFechaActual] = useState(new Date());
  const [vistaActual, setVistaActual] = useState("month");

  const [nuevaCita, setNuevaCita] = useState({
    nombre: "",
    familiar_responsable: "",
    fecha: "",
    fechaFin: "",
  });

  const fetchEventos = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/citas`, {
        headers: { Authorization: token }
      });
      const datos = res.data.map(cita => ({
        ...cita,
        title: `Residente: ${cita.nombre}`,
        start: new Date(cita.fecha),               // para el calendario
        end: new Date(cita.fechaFin || cita.fecha),
        fecha: cita.fecha,                         // para inputs
        fechaFin: cita.fechaFin || cita.fecha
      }));
      setEventos(datos);
    } catch (err) {
      console.error("❌ Error al cargar citas:", err);
    }
  };

  const handleGuardarNuevaCita = async () => {
    const token = localStorage.getItem("token");
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/citas`, nuevaCita, {
        headers: { Authorization: token }
      });
      alert("Cita guardada correctamente");
      setNuevaCitaVisible(false);
      setNuevaCita({ nombre: "", fecha: "", fechaFin: "", familiar_responsable: "" });
      fetchEventos();
    } catch (err) {
      alert("Error al guardar la cita");
    }
  };

  const handleSelectEvent = (event) => {
    setEventoSeleccionado({
      ...event,
      start: event.fecha,          // string tipo "2025-07-11T23:58"
      end: event.fechaFin
    });
  };

  const handleGuardar = async () => {
    const token = localStorage.getItem("token");
    try {
      const payload = {
        nombre: eventoSeleccionado.nombre,
        familiar_responsable: eventoSeleccionado.familiar_responsable || "",
        fecha: eventoSeleccionado.start,
        fechaFin: eventoSeleccionado.end
      };
      await axios.put(`${process.env.REACT_APP_API_URL}/api/citas/${eventoSeleccionado._id}`, payload, {
        headers: { Authorization: token }
      });
      alert("Cita actualizada");
      setEventoSeleccionado(null);
      fetchEventos();
    } catch {
      alert("Error al guardar");
    }
  };

  const handleEliminar = async () => {
    const token = localStorage.getItem("token");
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/citas/${eventoSeleccionado._id}`, {
        headers: { Authorization: token }
      });
      alert("Cita eliminada");
      setEventoSeleccionado(null);
      fetchEventos();
    } catch {
      alert("Error al eliminar");
    }
  };

  useEffect(() => {
    fetchEventos();
  }, []);

  return (
    <div className="p-4">
      <h2 className="text-primary mb-4">Calendario de Citas (WhatsApp)</h2>

      <button onClick={() => setNuevaCitaVisible(true)} className="btn btn-outline-primary mb-3">
        Nueva Cita
      </button>

      {nuevaCitaVisible && (
        <div className="card p-3 mb-4">
          <h5>Registrar Nueva Cita</h5>
          <label className="form-label">Nombre del residente:</label>
          <input
            className="form-control mb-2"
            placeholder="Nombre del residente"
            value={nuevaCita.nombre}
            onChange={e => setNuevaCita({ ...nuevaCita, nombre: e.target.value })}
          />

          <label className="form-label">Familiar responsable:</label>
          <input
            className="form-control mb-2"
            placeholder="Familiar responsable"
            value={nuevaCita.familiar_responsable}
            onChange={e => setNuevaCita({ ...nuevaCita, familiar_responsable: e.target.value })}
          />

          <label className="form-label">Fecha y hora de entrada:</label>
          <input
            type="datetime-local"
            className="form-control mb-2"
            value={nuevaCita.fecha}
            onChange={e => setNuevaCita({ ...nuevaCita, fecha: e.target.value })}
          />

          <label className="form-label">Fecha y hora de salida:</label>
          <input
            type="datetime-local"
            className="form-control mb-3"
            value={nuevaCita.fechaFin}
            min={nuevaCita.fecha || ""}
            onChange={e => setNuevaCita({ ...nuevaCita, fechaFin: e.target.value })}
          />

          <div className="d-flex gap-2">
            <button onClick={handleGuardarNuevaCita} className="btn btn-success">Guardar</button>
            <button onClick={() => setNuevaCitaVisible(false)} className="btn btn-secondary">Cancelar</button>
          </div>
        </div>
      )}

      <Calendar
        localizer={localizer}
        culture="es"
        events={eventos}
        startAccessor="start"
        endAccessor="end"
        date={fechaActual}
        view={vistaActual}
        onNavigate={setFechaActual}
        onView={setVistaActual}
        style={{ height: 500 }}
        views={["month", "week", "day"]}
        popup
        toolbar
        selectable
        onSelectEvent={handleSelectEvent}
        messages={{
          next: "Siguiente",
          previous: "Anterior",
          today: "Hoy",
          month: "Mes",
          week: "Semana",
          day: "Día",
          agenda: "Agenda",
          noEventsInRange: "No hay eventos en este rango",
          showMore: (total) => `+${total} más`
        }}
      />

      {eventoSeleccionado && (
        <div className="mt-4">
          <h5>Editar Cita</h5>
          <label className="form-label">Nombre del residente:</label>
          <input className="form-control mb-2" value={eventoSeleccionado.nombre} onChange={e => setEventoSeleccionado({ ...eventoSeleccionado, nombre: e.target.value })} />
           <label className="form-label">Familiar responsable:</label>
          <input className="form-control mb-2" value={eventoSeleccionado.familiar_responsable || ""} onChange={e => setEventoSeleccionado({ ...eventoSeleccionado, familiar_responsable: e.target.value })} />
          <label className="form-label">Fecha y hora de salida:</label>
          <input
            type="datetime-local"
            className="form-control mb-2"
            value={eventoSeleccionado.start}
            onChange={e => setEventoSeleccionado({ ...eventoSeleccionado, start: e.target.value })}
          />
          <label className="form-label">Fecha y hora de entrada:</label>
          <input
            type="datetime-local"
            className="form-control mb-2"
            value={eventoSeleccionado.end}
            onChange={e => setEventoSeleccionado({ ...eventoSeleccionado, end: e.target.value })}
          />
          <div className="d-flex gap-2 mt-2">
            <button className="btn btn-outline-primary" onClick={handleGuardar}>Guardar</button>
            <button className="btn btn-outline-danger" onClick={handleEliminar}>Eliminar</button>
            <button className="btn btn-outline-secondary" onClick={() => setEventoSeleccionado(null)}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
}
